import utils from '../../utils/index.js'
/**
 * 微信登录
 *
 * @param {*} code
 * @param {*}
 * @returns
 */
function wxLogin(appid, code) {
  return new Promise((resolve, reject) => {
    this.$http
      .post(
        utils.urls.wxLogin,
        {
          appId: appid,
          code: code
        },
        {
          headers: {}
        }
      )
      .then((res) => {
        resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}
/**
 * 手机号登录-验证码或者密码
 *
 * @param {*}
 * @param {*}
 * @returns
 */
function mobileLogin(params) {
  return new Promise((resolve, reject) => {
    this.$http
      .post(utils.urls.mobileLogin, {
        mobile: params.mobile,
        mode: params.mode, //登录模式。code:验证码，pwd:密码；默认使用验证码
        verifyCode: params.verifyCode, //密码登录模式，需输入加密的密码
        pwdEncrypt: params.pwdEncrypt
      })
      .then((res) => {
        resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

/**
 * 开课校验
 *
 * @param {*} 文档上不需要参数
 * @returns
 */
function openVerify(params) {
  return new Promise((resolve, reject) => {
    this.$http
      .get(utils.urls.openVerify, {
        headers: {
          token: params.token
        }
      })
      .then((res) => {
        resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}
/**
 * 获取用户信息
 *
 * @param {*} userGet
 * @returns
 */
function userGet(params) {
  return new Promise((resolve, reject) => {
    this.$http
      .get(utils.urls.userGet, {
        headers: {
          token: params.token
        }
      })
      .then((res) => {
        resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

/**
 * 开课
 *
 * @param {*}
 * @param {*}
 * @returns
 */
function open(params) {
  return new Promise((resolve, reject) => {
    this.$http
      .post(
        utils.urls.open,
        {
          birth: params.birth,
          gender: params.gender,
          name: params.name,
          role: params.role,
          thirdId: params.thirdId
        },
        {
          headers: {
            token: params.token
          }
        }
      )
      .then((res) => {
        resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}
/**
 * 兑换课程
 * @param {*}
 * @param {*}
 * @returns
 */
function redeem(params) {
  return new Promise((resolve, reject) => {
    this.$http
      .post(
        utils.urls.redeem,
        {
          redeemCode: params.redeemCode
        },
        {
          headers: {
            token: params.token
          }
        }
      )
      .then((res) => {
        resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}
/**
 * 课程列表
 *
 * @param {*}
 * @returns
 */
function courseList(params) {
  return new Promise((resolve, reject) => {
    this.$http
      .get(utils.urls.courseList, {
        params: {},
        headers: {
          token: params.token
        }
      })
      .then((res) => {
        resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

/**
 * 课程学习上报
 *
 * @param {*}
 * @param {*}
 * @returns
 */
function reportLearn(params) {
  return new Promise((resolve, reject) => {
    this.$http
      .post(
        utils.urls.reportLearn,
        {
          id: params.id
        },
        {
          headers: {
            token: params.token
          }
        }
      )
      .then((res) => {
        resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}
/**
 * feedback
 *
 * @param {*}
 * @param {*}
 * @returns
 */
function feedback(params) {
  return new Promise((resolve, reject) => {
    this.$http
      .post(
        utils.urls.feedback,
        {
          content: params.content //课程ID
        },
        {
          headers: {
            token: params.token
          }
        }
      )
      .then((res) => {
        resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

/**
 * banner列表
 *
 * @param {*}
 * @returns
 */
function bannerList(params) {
  return new Promise((resolve, reject) => {
    this.$http
      .get(utils.urls.bannerList, {
        params: {},
        headers: {
          token: params.token
        }
      })
      .then((res) => {
        resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

/**
 * 设置用户密码
 *
 * @param {*}
 * @param {*}
 * @returns
 */
function resetPwd(params) {
  return new Promise((resolve, reject) => {
    this.$http
      .post(
        utils.urls.resetPwd,
        {
          mobile: params.mobile,
          pwdEncrypt: params.pwdEncrypt,
          verifyCode: params.verifyCode
        },
        {
          headers: {
            token: params.token
          }
        }
      )
      .then((res) => {
        resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}
/**
 * 更换手机号
 *
 * @param {*}
 * @param {*}
 * @returns
 */
function mobileModify(params) {
  return new Promise((resolve, reject) => {
    this.$http
      .post(
        utils.urls.mobileModify,
        {
          mobile: params.mobile,
          verifyCode: params.verifyCode
        },
        {
          headers: {
            token: params.token
          }
        }
      )
      .then((res) => {
        resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

/**
 * 用户资料编辑
 *
 * @param {*}
 * @param {*}
 * @returns
 */
function infoModify(params) {
  return new Promise((resolve, reject) => {
    this.$http
      .post(
        utils.urls.infoModify,
        {
          birth: params.birth,
          gender: params.gender,
          name: params.name,
          role: params.role
        },
        {
          headers: {
            token: params.token
          }
        }
      )
      .then((res) => {
        resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

/**
 * 用户换绑微信申请创建
 *
 * @param {*}
 * @param {*}
 * @returns
 */
function createBind(params) {
  return new Promise((resolve, reject) => {
    this.$http
      .post(
        utils.urls.createBind,
        {},
        {
          headers: {
            token: params.token
          }
        }
      )
      .then((res) => {
        resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}
/**
 * 微信绑定用户(换绑微信)
 *
 * @param {*}
 * @param {*}
 * @returns
 */
function execute(params) {
  return new Promise((resolve, reject) => {
    this.$http
      .post(
        utils.urls.execute,
        {
          applyId: params.applyId,
          thirdId: params.thirdId
        },
        {
          headers: {}
        }
      )
      .then((res) => {
        resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

/**
 * 用户换绑微信申请查询
 *
 * @param {*}
 * @returns
 */
function checkBind(params) {
  return new Promise((resolve, reject) => {
    this.$http
      .get(utils.urls.checkBind, {
        params: {
          id: params.id
        }
      })
      .then((res) => {
        resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

/**
 * code获取用户信息-被邀请人
 *
 * @param {*} code
 * @param {*}
 * @returns
 */
function wxLoginJoin(appid, code, reqId) {
  console.log('新登录单数-----', appid, code, reqId)
  return new Promise((resolve, reject) => {
    this.$http
      .post(
        utils.urls.wxLoginJoin,
        {
          appId: appid,
          code: code,
          inviteId: reqId
        },
        {
          headers: {}
        }
      )
      .then((res) => {
        resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

/**
 * 下单
 *
 * @param {*} code
 * @param {*}
 * @returns
 */
function createOrder(params) {
  return new Promise((resolve, reject) => {
    this.$http
      .post(
        utils.urls.create,
        {
          ads: params.ads,
          itemId: params.itemId,
          itemType: params.itemType || 0,
          payType: params.payType || 1,
          reqId: params.reqId,
          tradeType: params.tradeType,
          mobile: params.mobile,
          delivery: params.delivery
        },
        {
          headers: {
            token: params.token
          }
        }
      )
      .then((res) => {
        resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

/**
 * 0元下单
 *
 * @param {*} code
 * @param {*}
 * @returns
 */
function createZeroOrder(params) {
  return new Promise((resolve, reject) => {
    this.$http
      .post(
        utils.urls.createZero,
        {
          itemId: params.itemId,
          itemType: params.itemType || 1,
          payType: params.payType || 99,
          tradeType: params.tradeType
        },
        {
          headers: {
            token: params.token
          }
        }
      )
      .then((res) => {
        resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}
/**
 * 取消订单
 *
 * @param {*}
 * @param {*}
 * @returns
 */
function cancelOrder(params) {
  return new Promise((resolve, reject) => {
    this.$http
      .post(
        utils.urls.cancel,
        {
          id: params.orderId
        },
        {
          headers: {
            token: params.token
          }
        }
      )
      .then((res) => {
        resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}
/**
 * 领取奖品
 *
 * @param {*}
 * @param {*}
 * @returns
 */
function recvGift(params) {
  return new Promise((resolve, reject) => {
    this.$http
      .post(
        utils.urls.recvGift,
        {
          delivery: params.delivery,
          giftLevel: params.level,
          inviteId: params.inviteId,
          mobile: params.mobile
        },
        {
          headers: {
            token: params.token
          }
        }
      )
      .then((res) => {
        resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

/**
 * 查活商品详情
 *
 * @param {*} activeId 活动id
 * @returns
 */
function getActiveInfomation(params) {
  return new Promise((resolve, reject) => {
    this.$http
      .get(utils.urls.detail, {
        params: {
          itemId: params.saleItem
        },
        headers: {
          token: params.token
        }
      })
      .then((res) => {
        resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

/**
 * 查活邀请有礼活动详情
 *
 * @param {*} activeId 活动id
 * @returns
 */
function getPromoDetailInfomation(params) {
  return new Promise((resolve, reject) => {
    this.$http
      .get(utils.urls.promoDetail, {
        params: {
          id: params.id
        },
        headers: {
          token: params.token
        }
      })
      .then((res) => {
        resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}
/**
 * 我的订单列表
 *
 * @param {*} a
 * @returns
 */
function orderList(params) {
  return new Promise((resolve, reject) => {
    this.$http
      .get(utils.urls.orderList, {
        params: {},
        headers: {
          token: params.token
        }
      })
      .then((res) => {
        resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}
/**
 * 查物流
 *
 * @param {*} a
 * @returns
 */
function delivery(params) {
  return new Promise((resolve, reject) => {
    this.$http
      .get(utils.urls.delivery, {
        params: {
          id: params.orderId
        },
        headers: {
          token: params.token
        }
      })
      .then((res) => {
        resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}
/**
 * 查进度
 *
 * @param {*} a
 * @returns
 */
function inviteTask(params) {
  return new Promise((resolve, reject) => {
    this.$http
      .get(utils.urls.inviteTask, {
        params: {
          inviteId: params.inviteId
        },
        headers: {
          token: params.token
        }
      })
      .then((res) => {
        resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}
/**
 * 查询我邀请的人的记录
 *
 * @param {*}
 * @returns
 */
function getHistory(params) {
  return new Promise((resolve, reject) => {
    this.$http
      .get(utils.urls.getHistory, {
        params: {
          inviteId: params.inviteId
        },
        headers: {
          token: params.token
        }
      })
      .then((res) => {
        resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}
/**
 * 查询我的邀请记录
 *
 * @param {*}
 * @returns
 */
function inviteGet(params) {
  return new Promise((resolve, reject) => {
    this.$http
      .get(utils.urls.inviteGet, {
        params: {
          promoId: params.promoId
        },
        headers: {
          token: params.token
        }
      })
      .then((res) => {
        resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}
/**
 * 我获得的礼包
 *
 * @param {*}
 * @returns
 */
function giftList(parmas) {
  return new Promise((resolve, reject) => {
    this.$http
      .get(utils.urls.giftList, {
        params: {
          inviteId: parmas.inviteId,
          promoId: parmas.promoId
        },
        headers: {
          token: parmas.token
        }
      })
      .then((res) => {
        resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}
/**
 * 我获得的礼包-详情
 *
 * @param {*}
 * @returns
 */
function giftDetail(params) {
  return new Promise((resolve, reject) => {
    this.$http
      .get(utils.urls.giftDetail, {
        params: {
          recvId: params.recvId
        },
        headers: {
          token: params.token
        }
      })
      .then((res) => {
        resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}
/**
 * 校验购买权限
 *
 * @param {*}
 * @returns
 */
function buyVerify(params) {
  return new Promise((resolve, reject) => {
    this.$http
      .get(utils.urls.buyVerify, {
        params: {
          itemId: params.itemId,
          inviteId: params.inviteId
        },
        headers: {
          token: params.token
        }
      })
      .then((res) => {
        resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

/**
 * 发起邀请
 *
 * @param {*}
 * @param {*}
 * @returns
 */
function inviteSave(params) {
  return new Promise((resolve, reject) => {
    this.$http
      .post(
        utils.urls.inviteSave,
        {
          promoId: params.promoId
        },
        {
          headers: {
            token: params.token,
            channel: params.channel
          }
        }
      )
      .then((res) => {
        resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}
/**
 * 加入邀请
 *
 * @param {*}
 * @param {*}
 * @returns
 */
function joinIn(params) {
  return new Promise((resolve, reject) => {
    this.$http
      .post(
        utils.urls.joinIn,
        {
          reqId: params.reqId
        },
        {
          headers: {
            token: params.token
          }
        }
      )
      .then((res) => {
        resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}
/**
 * 发送验证码
 *
 * @param {*}
 * @param {*}
 * @returns
 */
function sendCode(params) {
  return new Promise((resolve, reject) => {
    this.$http
      .post(utils.urls.sendCode, {
        mobile: params.mobile,
        type: params.type
      })
      .then((res) => {
        resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export default {
  wxLogin,
  mobileLogin,
  openVerify,
  open,
  redeem,
  courseList,
  reportLearn,
  feedback,
  bannerList,
  resetPwd,
  infoModify,
  userGet,
  mobileModify,
  createBind,
  execute,
  checkBind,

  createOrder, //1
  getActiveInfomation, //1
  getPromoDetailInfomation, //1
  wxLoginJoin, //废弃
  cancelOrder, //1
  getHistory, //1
  inviteGet, //1
  inviteSave, //1
  recvGift, //1
  giftList, //1
  giftDetail, //1
  buyVerify, //1
  orderList, //1
  delivery, //1
  inviteTask, //1
  joinIn,
  sendCode,
  createZeroOrder
}
